<section class="skills_section">
    <div class="about__data">
        <h1 class="section_title">Nuestros Servicios</h1>

        <div class="services_container">

            <div class="service_card">
                <h3>Automatización Comercial</h3>
                <p>
                    Optimizamos cada punto de tu negocio con soluciones digitales que integran software, hardware y
                    conectividad total.
                    Desde la venta hasta la gestión de inventario, automatizamos los procesos para que tomes decisiones
                    basadas en datos reales.
                </p>
                <ul>
                    <li>Sistemas POS inteligentes (web y app móvil)</li>
                    <li>Integración con balanzas, impresoras térmicas, etiqueteras y scanners</li>
                    <li>Reportes y control de ventas en tiempo real</li>
                    <li>Sincronización con la nube y respaldo automático</li>
                    <li>Adaptacion de sistema offline para entornos sin conexión a red</li>

                </ul>
            </div>

            <div class="service_card">
                <h3>Automatización Industrial</h3>
                <p>
                    Diseñamos soluciones que conectan máquinas, sensores y plataformas digitales para aumentar la
                    eficiencia operativa, reducir tiempos y optimizar recursos.
                </p>
                <ul>
                    <li>Control y monitoreo de procesos industriales</li>
                    <li>Integración de sensores IoT y PLCs</li>
                    <li>Paneles de supervisión en tiempo real</li>
                    <li>Alarmas automáticas y mantenimiento predictivo</li>
                </ul>
            </div>

            <div class="service_card">
                <h3>Domótica y Hogares Inteligentes</h3>
                <p>
                    Llevamos la automatización a tu hogar con soluciones que brindan confort, seguridad y eficiencia
                    energética.
                    Convierte tu casa en un entorno inteligente, controlado desde tu móvil o asistente virtual.
                </p>
                <ul>
                    <li>Control de iluminación, climatización y persianas</li>
                    <li>Cámaras de seguridad, alarmas y acceso remoto</li>
                    <li>Automatización del consumo energético</li>
                    <li>Integración con Alexa, Google Home y sistemas personalizados</li>
                </ul>
            </div>

            <div class="service_card">
                <h3>Desarrollo de Soluciones Personalizadas</h3>
                <p>
                    Diseñamos software y sistemas de automatización a medida, integrando tus dispositivos y procesos en
                    un solo entorno digital.
                </p>
                <ul>
                    <li>Aplicaciones móviles y plataformas web conectadas a hardware</li>
                    <li>Integración de APIs, Bluetooth, Wi-Fi o red local</li>
                    <li>Dashboards de monitoreo y analítica de datos</li>
                    <li>Soluciones escalables para cualquier sector</li>
                </ul>
            </div>

        </div>


       <!--  <h2 class="tech_title">Tecnologías que Dominamos</h2>
        <div class="technologies_container">
            <div class="technology" data-name="Java">
                <img src="assets/logos/java-logo.png" alt="Java Logo">
            </div>
            <div class="technology" data-name="HTML">
                <img src="assets/logos/html-logo.png" alt="HTML Logo">
            </div>
            <div class="technology" data-name="CSS">
                <img src="assets/logos/css-logo.png" alt="CSS Logo">
            </div>
            <div class="technology" data-name="Angular">
                <img src="assets/logos/angular-logo.png" alt="Angular Logo">
            </div>
            <div class="technology" data-name="Node.js">
                <img src="assets/logos/nodejs-logo.png" alt="Node.js Logo">
            </div>
            <div class="technology" data-name="React">
                <img src="assets/logos/reactnative-logo.png" alt="React Native Logo">
            </div>
            <div class="technology" data-name="Aws">
                <img src="assets/logos/aws-logo.png" alt="Aws Logo">
            </div>
            <div class="technology" data-name="Firebase">
                <img src="assets/logos/firebase-logo.png" alt="Firebase Logo">
            </div>
            <div class="technology" data-name="GitHub">
                <img src="assets/logos/github-logo.png" alt="GitHub Logo">
            </div>
            <div class="technology" data-name="GitLab">
                <img src="assets/logos/gitlab-logo.png" alt="GitLab Logo">
            </div>
            <div class="technology" data-name="Jira">
                <img src="assets/logos/jira-logo.png" alt="Jira Logo">
            </div>
            <div class="technology" data-name="PostgreSQL">
                <img src="assets/logos/postgresql-logo.png" alt="PostgreSQL Logo">
            </div>

            <div class="technology" data-name="Sql Server">
                <img src="assets/logos/sqlserver-logo.png" alt="Sql Server Logo">
            </div>
            <div class="technology" data-name="Oracle">
                <img src="assets/logos/oracle-logo.png" alt="Oracle Logo">
            </div>
            <div class="technology" data-name="Docker">
                <img src="assets/logos/docker-logo.png" alt="Docker Logo">
            </div>
            <div class="technology" data-name="SolidWork">
                <img src="assets/logos/solidwork-logo.png" alt="SolidWork Logo">
            </div>
            <div class="technology" data-name="Matlab">
                <img src="assets/logos/matlab-logo.png" alt="Matlab Logo">
            </div>
            <div class="technology" data-name="Python">
                <img src="assets/logos/python-logo.png" alt="Python Logo">
            </div>
            <div class="technology" data-name="TensorFlow">
                <img src="assets/logos/tensorflow-logo.png" alt="TensorFlow Logo">
            </div>
        </div> -->
    </div>

</section>